module.exports = __webpack_public_path__ + "img/energyImg5.f44c4823.png";